import { render, staticRenderFns } from "./StatusReceipt.vue?vue&type=template&id=63421afe&"
import script from "./StatusReceipt.vue?vue&type=script&lang=ts&"
export * from "./StatusReceipt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports